export function isInternalLink() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$href = _ref.href,
    href = _ref$href === void 0 ? '' : _ref$href;
  return href.startsWith('/');
}